import React from "react";

import { NavigateOptions, useNavigate } from "react-router-dom";

import { useSnackbarActionsContext } from "commons/context/snackbar";

function useSnackbar() {
    const navigate = useNavigate();

    const { enqueueSnackbar } = useSnackbarActionsContext();

    const enqueueSuccessSnackbar = React.useCallback(
        (message: string | JSX.Element) => enqueueSnackbar(message, "SUCCESS"),
        [enqueueSnackbar]
    );

    const enqueueErrorSnackbar = React.useCallback(
        (message: string | JSX.Element) => enqueueSnackbar(message, "ERROR"),
        [enqueueSnackbar]
    );

    const enqueueFormErrorSnackbar = React.useCallback(
        () => enqueueErrorSnackbar("Controlla che il form sia compilato in tutte le sue parti"),
        [enqueueErrorSnackbar]
    );

    const enqueueSuccessSnackbarThenNavigate = React.useCallback(
        (message: string | JSX.Element, to: string, options?: NavigateOptions) => {
            enqueueSuccessSnackbar(message);

            navigate(to, options);
        },
        [enqueueSuccessSnackbar, navigate]
    );

    const enqueueErrorSnackbarThenNavigate = React.useCallback(
        (message: string | JSX.Element, to: string, options?: NavigateOptions) => {
            enqueueErrorSnackbar(message);

            navigate(to, options);
        },
        [enqueueErrorSnackbar, navigate]
    );

    return React.useMemo(
        () => ({
            enqueueSuccessSnackbar,
            enqueueErrorSnackbar,
            enqueueSuccessSnackbarThenNavigate,
            enqueueErrorSnackbarThenNavigate,
            enqueueFormErrorSnackbar,
        }),
        [
            enqueueSuccessSnackbar,
            enqueueErrorSnackbar,
            enqueueSuccessSnackbarThenNavigate,
            enqueueErrorSnackbarThenNavigate,
            enqueueFormErrorSnackbar,
        ]
    );
}

export default useSnackbar;
